// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ecl-measure-content-div {
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: var(--padding);
}

.measure-label,
.measure-value {
   max-width: 100%;
   white-space: nowrap;
   overflow: hidden;
   text-overflow: ellipsis;
}

.measure-label {
   font-weight: normal;
   padding: 0;
}

.measure-value {
   font-size: 1.25rem;
   font-weight: bold;
   padding: 0;
}
.ecl-measure-text-div {
   display: flex;
   align-items: center;
   position: relative;
}
.ecl-measure-content-div #arrow-up,
.ecl-measure-content-div #arrow-down {
   height: 1.25rem;
   position: relative;
   top: 2px;
   left: 4px;
}`, "",{"version":3,"sources":["webpack://./src/eclComponents/Widgets/ECLDataViz/ECLMeasure/ECLMeasure.css"],"names":[],"mappings":"AAAA;GACG,WAAW;GACX,aAAa;GACb,sBAAsB;GACtB,mBAAmB;GACnB,uBAAuB;AAC1B;;AAEA;;GAEG,eAAe;GACf,mBAAmB;GACnB,gBAAgB;GAChB,uBAAuB;AAC1B;;AAEA;GACG,mBAAmB;GACnB,UAAU;AACb;;AAEA;GACG,kBAAkB;GAClB,iBAAiB;GACjB,UAAU;AACb;AACA;GACG,aAAa;GACb,mBAAmB;GACnB,kBAAkB;AACrB;AACA;;GAEG,eAAe;GACf,kBAAkB;GAClB,QAAQ;GACR,SAAS;AACZ","sourcesContent":[".ecl-measure-content-div {\r\n   width: 100%;\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n   padding: var(--padding);\r\n}\r\n\r\n.measure-label,\r\n.measure-value {\r\n   max-width: 100%;\r\n   white-space: nowrap;\r\n   overflow: hidden;\r\n   text-overflow: ellipsis;\r\n}\r\n\r\n.measure-label {\r\n   font-weight: normal;\r\n   padding: 0;\r\n}\r\n\r\n.measure-value {\r\n   font-size: 1.25rem;\r\n   font-weight: bold;\r\n   padding: 0;\r\n}\r\n.ecl-measure-text-div {\r\n   display: flex;\r\n   align-items: center;\r\n   position: relative;\r\n}\r\n.ecl-measure-content-div #arrow-up,\r\n.ecl-measure-content-div #arrow-down {\r\n   height: 1.25rem;\r\n   position: relative;\r\n   top: 2px;\r\n   left: 4px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
